import React, {
  ReactElement, useEffect, useState,
} from "react";
import { Button, Dropdown, Form, Input, Menu, Modal, notification, Radio, Row, Space } from "antd";
import { DownOutlined, SearchOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux'
import { unwrapResult } from '@reduxjs/toolkit'
import { NavBar } from "../../compnents/nav/NavBar";
import { EditableList } from "../../compnents/list/EditableList";
import { MemberBenefitsColumns } from "./columns";
import { AddItem } from "./memberBenefitsModals/AddItem";
import { AddTreatment } from "./memberBenefitsModals/AddTreatment";
import { AddItemCategory } from "./memberBenefitsModals/AddItemCategory";
import { AddTreatmentCategory } from "./memberBenefitsModals/AddTreatmentCategory";
import { getMemberInterestPageAsync, getMemberInterestDetailAsync, submitMemberInterestAsync, getMemberInterestExceptionPageAsync, deleteMemberInterestAsync } from "./memberBenefitsSlice";
import { RootDispatch } from "../../app/store";
import styles from "./MembersManagementPage.module.css";
import { BillingCategoryName } from "../../models/billingCategory";
import { selectSettings } from "../../features/user/setting/settingSlice";
import { TreatmentBillingCategories } from "../../models/billingCategory";

const determineEditType = (record: any): 'category' | 'treatment' | 'goods' => {
  if (record.billingCategory) return 'category'
  return record.catalogType == 1 ? 'treatment' : 'goods'
}


export const MemberBenefits = ({ inTab = false }: { inTab?: boolean }): ReactElement => {

  const dispatch = useDispatch<RootDispatch>()
  const settings = useSelector(selectSettings)

  const [data, setData] = useState<any[]>([]);
  const [loading, setLoading] = useState(false)
  const [searchName, setSearchName] = useState('')
  const [total, setTotal] = useState(0)

  const [queries, setQueries] = useState<any>({ current: 1, size: 10 })

  const [addItemVisible, setAddItemVisible] = useState(false)
  const [addTreatmentVisible, setAddTreatmentVisible] = useState(false)
  const [addItemCategoryVisible, setAddItemCategoryVisible] = useState(false)
  const [addTreatmentCategoryVisible, setAddTreatmentCategoryVisible] = useState(false)

  const [editVisible, setEditVisible] = useState(false)
  const [editRecord, setEditRecord] = useState<any>(null)
  const [editType, setEditType] = useState<'category' | 'treatment' | 'goods'>('goods')
  const [editForm] = Form.useForm()
  const [editLoading, setEditLoading] = useState(false)

  const [exceptionVisible, setExceptionVisible] = useState(false)
  const [exceptionRecord, setExceptionRecord] = useState<any>(null)
  const [exceptionDefaultKeys, setExceptionDefaultKeys] = useState<React.Key[]>([])
  const [exceptionDefaultRows, setExceptionDefaultRows] = useState<any[]>([])
  const [editDiscountType, setEditDiscountType] = useState(0)
  const [editDetail, setEditDetail] = useState<any>(null)
  const [cachedDiscountPrice, setCachedDiscountPrice] = useState<any>(null)
  const [cachedSpecialPrice, setCachedSpecialPrice] = useState<any>(null)

  const [addItemDefaultKeys, setAddItemDefaultKeys] = useState<React.Key[]>([])
  const [addItemDefaultRows, setAddItemDefaultRows] = useState<any[]>([])
  const [addTreatmentDefaultKeys, setAddTreatmentDefaultKeys] = useState<React.Key[]>([])
  const [addTreatmentDefaultRows, setAddTreatmentDefaultRows] = useState<any[]>([])

  const getPage = () => {
    setLoading(true)
    dispatch(getMemberInterestPageAsync(queries))
      .then(unwrapResult)
      .then((res: any) => {
        setData(res?.records || [])
        setTotal(res?.total || 0)
      })
      .finally(() => {
        setLoading(false)
      })
  }

  useEffect(() => {
    getPage()
  }, [queries])


  const handleAction = (action: string, record: any) => {
    if (action === 'edit') {
      const type = determineEditType(record)
      setEditType(type)
      setEditRecord(record)
      setEditDiscountType(record.discountType || 0)
      setEditLoading(true)
      dispatch(getMemberInterestDetailAsync({ id: record.id }))
        .then(unwrapResult)
        .then((res: any) => {
          setEditDetail(res)
          const formattedRes = {
            ...res,
            price: res.discountType === 1 && res.price != null
              ? Number(res.price).toFixed(5)
              : res.price,
          }
          editForm.setFieldsValue(formattedRes)
          setEditDiscountType(res.discountType || 0)
          if (res.discountType === 1 && res.price != null) {
            setCachedSpecialPrice(Number(res.price).toFixed(5))
          }
        })
        .finally(() => {
          setEditLoading(false)
        })
      setEditVisible(true)
    } else if (action === 'delete') {
      Modal.confirm({
        title: '确认删除',
        content: `确定要删除「${record.name || ''}」吗？`,
        maskClosable: false,
        okText: '确定',
        cancelText: '取消',
        onOk: () => {
          dispatch(deleteMemberInterestAsync({ id: record.id }))
            .then(unwrapResult)
            .then(() => {
              notification.success({ message: '删除成功' })
              getPage()
            })
        },
      })
    }
  }

  return (
    <>
      {!inTab && (
        <NavBar
          style={{ margin: "10px 20px 0px 20px" }}
          where={["会员管理", "会员权益"]}
          backtrace={{
            name: "患者管理",
            path: "/statistics/outpatient",
          }}
        />
      )}
      <div className={styles.memberContent} style={inTab ? { margin: '5px 0', height: 'calc(100% - 10px)' } : undefined}>
        <Row className={styles.memberContentTitle}>会员折扣权益</Row>
        <Row justify="space-between" align="middle" style={{ margin: '15px 0 18px' }}>
          <Space size={10}>
            <Dropdown
              trigger={['click']}
              overlay={
                <Menu>
                  <Menu.Item key="goodsCategory" onClick={() => setAddItemCategoryVisible(true)}>添加商品分类</Menu.Item>
                  <Menu.Item key="treatmentCategory" onClick={() => setAddTreatmentCategoryVisible(true)}>添加诊疗分类</Menu.Item>
                </Menu>
              }
            >
              <Button type="primary">
                添加分类 <DownOutlined />
              </Button>
            </Dropdown>
            <Dropdown
              trigger={['click']}
              overlay={
                <Menu>
                  <Menu.Item key="goods" onClick={() => {
                    setAddItemVisible(true)
                  }}>添加商品</Menu.Item>
                  <Menu.Item key="treatment" onClick={() => {
                    setAddTreatmentVisible(true)
                  }}>添加诊疗</Menu.Item>
                </Menu>
              }
            >
              <Button type="primary">
                添加项目 <DownOutlined />
              </Button>
            </Dropdown>
          </Space>
          <Space style={{ marginLeft: 'auto' }}>
            <Input
              placeholder="商品名称"
              prefix={<SearchOutlined />}
              value={searchName}
              allowClear
              onChange={(e) => {
                const val = e.target.value
                setSearchName(val)
                setQueries({ ...queries, name: val || undefined, current: 1 })
              }}
            />
            <Button type="primary" onClick={() => setQueries({ ...queries, name: searchName || undefined, current: 1 })}>查询</Button>
          </Space>
        </Row>
        
        <EditableList
          className={styles.supper}
          loading={loading}
          rowKey={(t: any) => t.id}
          bordered
          page={{
            items: data,
            current: queries.current || 1,
            size: queries.size || 10,
            total,
          }}
          onChangePage={(current, size) =>
            setQueries({ ...queries, current, size: size || 10 })
          }
          sticky
          columns={MemberBenefitsColumns(handleAction, 0, settings)}
        />
      </div>
      <AddItem
        visible={addItemVisible}
        defaultSelectedRowKeys={addItemDefaultKeys}
        defaultSelectedRows={addItemDefaultRows}
        onCancel={() => {
          setAddItemVisible(false)
          setAddItemDefaultKeys([])
          setAddItemDefaultRows([])
          getPage()
        }}
        onOk={(selectedRows) => {
          console.log('选中的商品:', selectedRows)
          setAddItemVisible(false)
          setAddItemDefaultKeys([])
          setAddItemDefaultRows([])
          getPage()
        }}
      />
      <AddTreatment
        visible={addTreatmentVisible}
        defaultSelectedRowKeys={addTreatmentDefaultKeys}
        defaultSelectedRows={addTreatmentDefaultRows}
        onCancel={() => {
          setAddTreatmentVisible(false)
          setAddTreatmentDefaultKeys([])
          setAddTreatmentDefaultRows([])
          getPage()
        }}
        onOk={(selectedRows) => {
          console.log('选中的诊疗:', selectedRows)
          setAddTreatmentVisible(false)
          setAddTreatmentDefaultKeys([])
          setAddTreatmentDefaultRows([])
          getPage()
        }}
      />
      <AddItemCategory
        visible={addItemCategoryVisible}
        onRefresh={getPage}
        onCancel={() => {
          setAddItemCategoryVisible(false)
          getPage()
        }}
        onOk={(data) => {
          console.log('商品分类数据:', data)
          setAddItemCategoryVisible(false)
          getPage()
        }}
      />
      <AddTreatmentCategory
        visible={addTreatmentCategoryVisible}
        onRefresh={getPage}
        onCancel={() => {
          setAddTreatmentCategoryVisible(false)
          getPage()
        }}
        onOk={(data) => {
          console.log('诊疗分类数据:', data)
          setAddTreatmentCategoryVisible(false)
          getPage()
        }}
      />
      <Modal
        title="会员编辑"
        visible={editVisible}
        maskClosable={false}
        onCancel={() => setEditVisible(false)}
        onOk={() => {
          editForm.validateFields().then((values) => {
            const params = {
              id: editDetail?.id,
              name: editDetail?.name,
              tenantId: editDetail?.tenantId,
              tenantCatalogId: editDetail?.tenantCatalogId,
              catalogType: editDetail?.catalogType,
              tenantInventoryId: editDetail?.tenantInventoryId,
              discountType: values.discountType ?? editDetail?.discountType,
              price: values.price ?? editDetail?.price,
            }
            setEditLoading(true)
            dispatch(submitMemberInterestAsync(params))
              .then(unwrapResult)
              .then(() => {
                notification.success({ message: '操作成功' })
                setEditVisible(false)
                getPage()
              })
              .finally(() => {
                setEditLoading(false)
              })
          })
        }}
        confirmLoading={editLoading}
        destroyOnClose
      >
        <Form form={editForm} layout="horizontal" labelAlign="right" labelCol={{ span: 5 }} wrapperCol={{ span: 19 }}>
          {editType === 'category' && (
            <>
              <Form.Item label="开票项目">
                <span>{BillingCategoryName(editRecord?.billingCategory)}</span>
              </Form.Item>
              <Form.Item label="折扣类型">
                <span>折扣</span>
              </Form.Item>
              <Form.Item
                label="会员价"
                name="price"
                rules={[
                  { required: true, message: '请输入会员价' },
                  { pattern: /^(100|[1-9]?\d)$/, message: '折扣请输入0-100的整数' },
                ]}
              >
                <Input addonAfter="%" style={{ width: 200 }} />
              </Form.Item>
              <Form.Item label="例外">
                <Space>
                  <span>例外 {editRecord?.specialNum || 0} 个</span>
                  <Button type="link" onClick={() => {
                    setExceptionRecord(editRecord)
                    dispatch(getMemberInterestExceptionPageAsync({ billingCategory: editRecord.billingCategory, catalogType: 0 }))
                      .then(unwrapResult)
                      .then((res: any) => {
                        const records: any[] = (res?.records || res || []).filter((v: any) => v && v.tenantCatalogId)
                        setExceptionDefaultKeys(records.map((v: any) => v.tenantCatalogId))
                        setExceptionDefaultRows(records.map((v: any) => ({
                          id: v.tenantCatalogId,
                          name: v.name,
                          retailPrice: v.retailPrice,
                          stockPrice: v.stockPrice,
                          spec: v.spec,
                          catalogType: v.catalogType ?? -1,
                          discountType: v.discountType ?? 0,
                          price: v.price,
                          totalNumStr: v.totalNumStr,
                          materialsCategory: v.materialsCategory,
                          packSpec: v.packSpec,
                          doseCategory: v.doseCategory,
                          tenantSupplierName: v.tenantSupplierName,
                          model: v.model,
                        })))
                        setExceptionVisible(true)
                      })
                  }}>
                    编辑例外
                  </Button>
                </Space>
              </Form.Item>
            </>
          )}
          {editType === 'treatment' && (
            <>
              <Form.Item label="诊疗名称">
                <span>{editRecord?.name}</span>
              </Form.Item>
              <Form.Item label="目录售价">
                <span>{editRecord?.retailPrice != null ? Number(editRecord.retailPrice).toFixed(5) : ''}</span>
              </Form.Item>
              <Form.Item label="成本价">
                <span>{editRecord?.costPrice != null && editRecord.costPrice >= 0 ? Number(editRecord.costPrice).toFixed(5) : ''}</span>
              </Form.Item>
              <Form.Item label="折扣类型" name="discountType">
                <Radio.Group onChange={(e) => {
                  const newType = e.target.value
                  if (editDiscountType === 0 && newType === 1) {
                    // 折扣 → 特价：缓存折扣价，回填特价缓存
                    setCachedDiscountPrice(editForm.getFieldValue('price'))
                    editForm.setFieldsValue({ price: cachedSpecialPrice ?? undefined })
                  } else if (editDiscountType === 1 && newType === 0) {
                    // 特价 → 折扣：缓存特价，回填折扣缓存
                    setCachedSpecialPrice(editForm.getFieldValue('price'))
                    editForm.setFieldsValue({ price: cachedDiscountPrice ?? undefined })
                  }
                  setEditDiscountType(newType)
                }}>
                  <Radio value={0}>折扣</Radio>
                  <Radio value={1}>特价</Radio>
                </Radio.Group>
              </Form.Item>
              <Form.Item label="会员价"
                name="price"
                rules={[
                  { required: true, message: '请输入会员价' },
                  editDiscountType == 1
                    ? { pattern: /^(0|[1-9]\d*)(\.\d{1,5})?$/, message: '请输入数字，支持小数点后五位' }
                    : { pattern: /^(100|[1-9]?\d)$/, message: '折扣请输入0-100的整数' },
                ]}
              >
                <Input
                  addonAfter={editDiscountType == 1 ? '元' : '%'}
                  style={{ width: 200 }}
                  onBlur={(e) => {
                    if (editDiscountType === 1 && e.target.value) {
                      const num = Number(e.target.value)
                      if (!isNaN(num)) {
                        editForm.setFieldsValue({ price: num.toFixed(5) })
                      }
                    }
                  }}
                />
              </Form.Item>
            </>
          )}
          {editType === 'goods' && (
            <>
              <Form.Item label="商品名称">
                <span>{editRecord?.name}</span>
              </Form.Item>
              <Form.Item label="目录售价">
                <span>{editRecord?.retailPrice != null ? Number(editRecord.retailPrice).toFixed(5) : ''}</span>
              </Form.Item>
              <Form.Item label="目录进价">
                <span>{editRecord?.stockPrice != null && editRecord.stockPrice >= 0 ? Number(editRecord.stockPrice).toFixed(5) : ''}</span>
              </Form.Item>
              <Form.Item label="折扣类型" name="discountType">
                <Radio.Group onChange={(e) => {
                  const newType = e.target.value
                  if (editDiscountType === 0 && newType === 1) {
                    // 折扣 → 特价：缓存折扣价，回填特价缓存
                    setCachedDiscountPrice(editForm.getFieldValue('price'))
                    editForm.setFieldsValue({ price: cachedSpecialPrice ?? undefined })
                  } else if (editDiscountType === 1 && newType === 0) {
                    // 特价 → 折扣：缓存特价，回填折扣缓存
                    setCachedSpecialPrice(editForm.getFieldValue('price'))
                    editForm.setFieldsValue({ price: cachedDiscountPrice ?? undefined })
                  }
                  setEditDiscountType(newType)
                }}>
                  <Radio value={0}>折扣</Radio>
                  <Radio value={1}>特价</Radio>
                </Radio.Group>
              </Form.Item>
              <Form.Item label="会员价"
                name="price"
                rules={[
                  { required: true, message: '请输入会员价' },
                  editDiscountType == 1
                    ? { pattern: /^(0|[1-9]\d*)(\.\d{1,5})?$/, message: '请输入数字，支持小数点后五位' }
                    : { pattern: /^(100|[1-9]?\d)$/, message: '折扣请输入0-100的整数' },
                ]}
              >
                <Input
                  addonAfter={editDiscountType == 1 ? '元' : '%'}
                  style={{ width: 200 }}
                  onBlur={(e) => {
                    if (editDiscountType === 1 && e.target.value) {
                      const num = Number(e.target.value)
                      if (!isNaN(num)) {
                        editForm.setFieldsValue({ price: num.toFixed(5) })
                      }
                    }
                  }}
                />
              </Form.Item>
            </>
          )}
        </Form>
      </Modal>
      {editType === 'treatment' || TreatmentBillingCategories.includes(editRecord?.billingCategory) ? (
        <AddTreatment
          visible={exceptionVisible}
          title={`编辑例外诊疗 - ${exceptionRecord?.name || ''}`}
          mode="exception"
          billingCategory={exceptionRecord?.billingCategory}
          defaultSelectedRowKeys={exceptionDefaultKeys}
          defaultSelectedRows={exceptionDefaultRows}
          onCancel={() => {
            setExceptionVisible(false)
            setExceptionDefaultKeys([])
            setExceptionDefaultRows([])
          }}
          onOk={() => {
            setExceptionVisible(false)
            getPage()
            if (editRecord?.id) {
              dispatch(getMemberInterestDetailAsync({ id: editRecord.id }))
                .then(unwrapResult)
                .then((res: any) => {
                  setEditDetail(res)
                  setEditRecord((prev: any) => ({ ...prev, specialNum: res.specialNum }))
                })
            }
          }}
        />
      ) : (
        <AddItem
          visible={exceptionVisible}
          title={`编辑例外商品 - ${exceptionRecord?.name || ''}`}
          mode="exception"
          billingCategory={exceptionRecord?.billingCategory}
          defaultSelectedRowKeys={exceptionDefaultKeys}
          defaultSelectedRows={exceptionDefaultRows}
          onCancel={() => {
            setExceptionVisible(false)
            setExceptionDefaultKeys([])
            setExceptionDefaultRows([])
          }}
          onOk={() => {
            setExceptionVisible(false)
            getPage()
            if (editRecord?.id) {
              dispatch(getMemberInterestDetailAsync({ id: editRecord.id }))
                .then(unwrapResult)
                .then((res: any) => {
                  setEditDetail(res)
                  setEditRecord((prev: any) => ({ ...prev, specialNum: res.specialNum }))
                })
            }
          }}
        />
      )}
    </>
  );
}
